export default __webpack_public_path__ + "logo-light.c3b8953b41e68ed5ca10190199193cfa.png";